import common from './zh_CN/common'
import areaCode from './zh_CN/areaCode'
import communicateCenter from './zh_CN/communicateCenter'
import components from './zh_CN/components'
import course from './zh_CN/course'
import courseDetail from './zh_CN/courseDetail'
import examDetail from './zh_CN/examDetail'
import home from './zh_CN/home'
import humanTraining from './zh_CN/humanTraining'
import inforList from './zh_CN/inforList'
import Information from './zh_CN/Information'
import intelligentOfficialDoc from './zh_CN/intelligentOfficialDoc'
import knowledgeLib from './zh_CN/knowledgeLib'
import LearnRecords from './zh_CN/LearnRecords'
import Login from './zh_CN/Login'
import myCourse from './zh_CN/myCourse'
import myExam from './zh_CN/myExam'
import mynews from './zh_CN/mynews'
import mySetting from './zh_CN/mySetting'
import mytopic from './zh_CN/mytopic'
import myTrainingClass from './zh_CN/myTrainingClass'
import myTrainingDetail from './zh_CN/myTrainingDetail'
import myWork from './zh_CN/myWork'
import post from './zh_CN/post'
import postDetail from './zh_CN/postDetail'
import practiceTrain from './zh_CN/practiceTrain'
import publicExam from './zh_CN/publicExam'
import questionnaire from './zh_CN/questionnaire'
import rules from './zh_CN/rules'
import search from './zh_CN/search'
import studyMap from './zh_CN/studyMap'
import topic from './zh_CN/topic'
import topicDetail from './zh_CN/topicDetail'
import topicManagerRange from './zh_CN/topicManagerRange'
import trainingClass from './zh_CN/trainingClass'
import trainingCourseDetail from './zh_CN/trainingCourseDetail'
import webLive from './zh_CN/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}
